const POW_2_TO_32 = Math.pow(2, 32);

/**
 * Converts the Long to the nearest floating-point representation of this value (double, 53 bit mantissa).
 * The official implementation can be found at https://github.com/dcodeIO/long.js/blob/master/src/long.js#L466.
 * This is copy-pasted here so that we don't pull an entire library just for this tiny logic.
 *
 * @param long
 */
export function longToNumber(long: any): number {
  if (typeof long.high !== 'number' || typeof long.low !== 'number') {
    throw new Error(`Unexpected long value`);
  }

  if (long.unsigned && typeof long.unsigned !== 'boolean') {
    throw new Error(`Unexpected long value`);
  }

  if (long.unsigned) {
    // tslint:disable-next-line:no-bitwise
    return (long.high >>> 0) * POW_2_TO_32 + (long.low >>> 0);
  }

  // tslint:disable-next-line:no-bitwise
  return long.high * POW_2_TO_32 + (long.low >>> 0);
}
